module.exports = __webpack_public_path__ + "static/img/68081E_7_R_20200731_LC.cc94a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/68081E_7_R_20200731_LC.png
// module id = ujsb
// module chunks = 0